import React, { useRef } from 'react';
import { useOutletContext, useParams } from 'react-router-dom';
import { Row } from 'react-table';

import { CardTransactionRow, cardTransactionColumns, mapCardTransactionRow } from '../CardTransactions/shared';
import { ROUTE } from '~/app/routes';
import { EmptyState, PaginationWrapper, PaginationWrapperRefProps, Section } from '~/components';
import { useNavigate } from '~/lib/navigation';
import { CardTransactionRepository, ListCardTransactionsParams } from '~/repositories/CardTransactionRepository';
import { Inner } from '~/styles';

import { CardProps } from './Card';

interface Params {
  id: string;
}

export const PageCardTransactions: React.FC = () => {
  const navigate = useNavigate();
  const { id: cardId } = useParams<keyof Params>() as Params;
  useOutletContext<CardProps>(); // Ensures we are nested in card details.
  const paginationRef = useRef<PaginationWrapperRefProps>(null);

  const handleFetch = async (params: ListCardTransactionsParams) => {
    return CardTransactionRepository.listCardTransactions({
      ...params,
      cardId,
    }).then((response) => ({
      entries: response.cardTransactions.map(mapCardTransactionRow),
      hasMore: Boolean(response.hasMore),
    }));
  };

  return (
    <Inner p={0}>
      <Section headline="Transactions">
        <PaginationWrapper
          tableId="card-detail-transactions"
          fetch={handleFetch}
          columns={cardTransactionColumns}
          ref={paginationRef}
          rowClick={(row: Row<CardTransactionRow>) => {
            navigate(`${ROUTE.CARD_TRANSACTIONS}/edit/${row.original.id}`);
          }}
          empty={<EmptyState headline="No transactions yet" text="Transactions will appear here for this card." />}
        />
      </Section>
    </Inner>
  );
};
